import {FormSelectType} from '../../../../blocks/FormBlock'
import {copy} from '../../../../../util/fieldscopy'

const howYouKnowField: FormSelectType = {
	id: 0,
	parent_id: 0,
	channel: 'select',
	label: copy?.howyouknow?.label || 'Hoe leerde jij {{eventName}} kennen?',
	name: 'howYouKnow',
	required: true,
	enableFilter: false,
	options: [
		{
			amount: null,
			path: 'collaborator',
			title:
				copy?.howyouknow?.collaborator ||
				'Via een medewerker van Broederlijk Delen'
		},
		{
			amount: null,
			path: 'participant',
			title: copy?.howyouknow?.participant || 'Via een (ex-)deelnemer'
		},
		{
			amount: null,
			path: 'event',
			title: copy?.howyouknow?.event || 'Op een evenement van Broederlijk Delen'
		},
		{
			amount: null,
			path: 'fair',
			title: copy?.howyouknow?.fair || 'Op een fiets- en wandelbeurs'
		},
		{
			amount: null,
			path: 'socialmedia',
			title: copy?.howyouknow?.socialmedia || 'Via onze sociale media'
		},
		{
			amount: null,
			path: 'newsletter',
			title: copy?.howyouknow?.newsletter || 'Via onze nieuwsbrief'
		},
		{
			amount: null,
			path: 'magazine',
			title: copy?.howyouknow?.magazine || 'Via ons magazine MEEgedeeld'
		},
		{
			amount: null,
			path: 'advertisement',
			title: copy?.howyouknow?.advertisement || 'Via een advertentie'
		}
	]
}

export default howYouKnowField
